import React from 'react'
import { ActionsMenu, Icon } from '@opallabs/lapidary'
import { ActionRenderer } from './ActionRenderer'
import type { Action, ContentCardOptionsMenuProps } from './types'

type SubMenuProps = {
  actions: Action[]
  parentProps: ContentCardOptionsMenuProps
  disabled?: boolean
  triggerLabel: string
}

export const SubMenu: React.FC<SubMenuProps> = ({
  actions,
  disabled,
  parentProps,
  triggerLabel,
}) => {
  // When just one regular action is provided, reduce submenu to action
  if (actions.length === 1 && actions[0].type === 'action') {
    const action = {
      ...actions[0],
      label: `${triggerLabel} ${actions[0].label}`,
    }

    return <ActionRenderer action={action} parentProps={parentProps} />
  }

  return (
    <ActionsMenu.Sub>
      <ActionsMenu.SubTrigger disabled={disabled}>
        {triggerLabel}
        <Icon glyph="gem-chevron-e" />
      </ActionsMenu.SubTrigger>
      <ActionsMenu.Portal>
        <ActionsMenu.SubContent
          className="lapidary-content-card-sub-menu"
          css={{ maxBlockSize: 288 }}
          style={{ zIndex: 9999 }}
        >
          {actions.map((action, i) => (
            <ActionRenderer
              key={
                action.type === 'separator'
                  ? `separator-${i}`
                  : action.actionType
              }
              action={action}
              parentProps={parentProps}
            />
          ))}
        </ActionsMenu.SubContent>
      </ActionsMenu.Portal>
    </ActionsMenu.Sub>
  )
}
